import {
  notificationRuleOptionsQuery,
  workspaceNotificationRulesQuery,
} from "@common/api/notification-rules"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { requirePermission } from "@/lib/require-permission"
import { ruleDefaults } from "../-components/form/schema"
import { RuleMissing } from "../-components/rule-missing"
import { RulePage } from "../-components/rule-page"
import { UPDATE_RULES_PERMISSION } from "../-lib/permission"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/notification-rules/$ruleId",
)({
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(
      queryClient,
      UPDATE_RULES_PERMISSION,
      "/settings/workspace/general",
    ),
  loader: async ({ context: { queryClient }, params: { ruleId } }) => {
    const [rules] = await Promise.all([
      queryClient.ensureQueryData(workspaceNotificationRulesQuery()),
      queryClient.ensureQueryData(notificationRuleOptionsQuery()),
    ])
    const rule = rules.rules.find((entry) => entry.id === ruleId)
    if (!rule) {
      throw redirect({
        to: "/settings/workspace/notification-rules",
        replace: true,
      })
    }
    return { breadcrumb: rule.name }
  },
  component: EditRulePage,
})

function EditRulePage(): React.ReactElement {
  const { ruleId } = Route.useParams()
  const { data } = useSuspenseQuery(workspaceNotificationRulesQuery())
  const rule = data.rules.find((entry) => entry.id === ruleId)

  return (
    <>
      {rule ? (
        <RulePage key={rule.id} rule={rule} defaults={ruleDefaults(rule)} />
      ) : (
        <RuleMissing />
      )}
      <Outlet />
    </>
  )
}
